import { REDIRECT_PAGE_KEY, REDIRECT_PAGE_SESSION } from 'contexts/AuthContext'
import { PROFILE_STORAGE_KEY } from 'pages/AddProfile/hooks/useForm'
import { updateStatusBarColor } from 'utils/updateStatusBarColor'
import { CART_STORAGE_KEY } from 'pages/Order/hooks/useCart'
import { loadState, removeItem } from 'utils/storage'
import { useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'

interface LocationListenerProps {
  children: JSX.Element
}

const LocationListener: React.FC<LocationListenerProps> = ({ children }) => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (
      pathname.startsWith('/') ||
      pathname.startsWith('/manage') ||
      pathname.startsWith('/savedprofiles') ||
      pathname.startsWith('/myprofiles') ||
      pathname.startsWith('/qrscanner') ||
      pathname.startsWith('/addprofile') ||
      pathname.startsWith('/map')
    ) {
      updateStatusBarColor('#f6f6f7')
    } else {
      updateStatusBarColor('#ffffff')
    }
  }, [pathname])

  useEffect(() => {
    if (pathname === '/') {
      if (loadState(REDIRECT_PAGE_SESSION, REDIRECT_PAGE_KEY, null)) {
        removeItem(REDIRECT_PAGE_SESSION, REDIRECT_PAGE_KEY)
      }

    } else if (pathname.includes('/order')) {
      return () => {
        removeItem(true, CART_STORAGE_KEY)
      }

    } else if (pathname.includes('/addprofile')) {
      return () => {
        removeItem(true, PROFILE_STORAGE_KEY)
      }
    }
  }, [pathname])

  return children
}

export default LocationListener